import { memo, useState } from "react";
import { MainLayoutV2 } from "../../components/main-layout-v2/main-layout-v2";
import { MainNavigation } from "../../components/main-navigation/main-navigation";
import { Sidebar } from "../../components/sidebar/sidebar";
import { Outlet } from "react-router-dom";

export const ContentPage = memo(() => {
  const navigation = [
    {
      label: null,
      type: "group",
      children: [
        { key: "/content/overview", label: "Overview" },
        { key: "/content/tasks", label: "Tasks" },
        { key: "/content/plans", label: "Plans" },
        { key: "/content/lifepoints", label: "LifePoints" },
        { key: "/content/categories", label: "Categories" },
        { key: "/content/tags", label: "Tags" },
        { key: "/content/articles", label: "Articles" },
        { key: "/content/fitfacts", label: "FitFacts" },
        { key: "/content/scenarios", label: "Scenarios" },
        { key: "/content/onboardings", label: "Onboarding" },
        { key: "/content/rules", label: "Rules" },
      ],
    },
  ];

  const [sidebarProps, setSidebarProps] = useState({ title: "Content" });

  return (
    <MainLayoutV2>
      <MainNavigation />
      <Sidebar items={navigation} {...sidebarProps} />
      <Outlet context={{ setSidebarProps }} />
    </MainLayoutV2>
  );
});